import React from 'react';
import MapWindStationPins from './MapWindStationPins';

MapWindStationPins.displayName = 'MapWindStationPins';

export default React.memo(MapWindStationPins);
